/* eslint-disable no-lone-blocks */
import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import AdsCard from "../../components/common/AdsCard/AdsCard";
import DefaultImage from "../../assets/img/default-image.jpg";
import CircularButton from "../../components/common/MainButton/CircularButton";
import useAuth from "../../Hooks/useAuth";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from 'swiper/modules';
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { GetPostsByUserIdAndStatus } from "../../services/PostService";
import { useGraphQL } from "../../context/GraphQLProvider";

const UserGigs = ({ grid = false }) => {
  const { auth } = useAuth();
  const location = useLocation();
  const graphqlService = useGraphQL();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // useRef must be at the top level
  const swiperRef = useRef();

  // Get user id from URL or session
  const params = new URLSearchParams(location.search);
  const userIdFromUrl = params.get("id");
  // Use auth.user.id if userIdFromUrl is null, undefined, or empty string
  const userId = userIdFromUrl ? userIdFromUrl : auth?.user;

  useEffect(() => {
    const fetchPosts = async () => {
      console.log(auth);
      if (!userId) return;
      setLoading(true);
      try {
        const response = await GetPostsByUserIdAndStatus(graphqlService, {
          userId: Number(userId),
          status: "published",
        });
        setPosts(response?.getPostsByStatus || []);
      } catch (e) {
        setPosts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [userId, graphqlService]);

  if (loading) {
    return <div className="text-center py-10 text-gray-400">Loading posts...</div>;
  }

  if (!posts.length) {
    return <div className="text-center py-10 text-gray-400">No posts found.</div>;
  }

  return (
    <>
      {/* <div>
        <SecondaryHeading
          variant={"MainParagraphHeading"}
          className={"text-offblack"}
        >
          Posts
        </SecondaryHeading>
      </div> */}
      {grid ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 mt-5">
          {posts.map((post, index) => {
            let images = [];
            try {
              if (post.content) {
                const contentArray = JSON.parse(post.content);
                images = contentArray.map(img => ({ url: img.url }));
              }
            } catch (e) {
              images = [];
            }
            if (!images.length) images = [{ url: 'https://via.placeholder.com/300x200' }];
            return (
              <AdsCard
                key={post.id}
                serviceId={post.id}
                serviceName={post.postTitle}
                serviceDescription={post.postDescription}
                Images={images}
                companyName={post.user?.businessName || 'Business name'}
                companyLogo={post.user?.profilePicture}
                category={post.user?.serviceCategory}
                likes={post.likes || 0}
                views={post.views || 0}
                reaction={false}
                companyId={post.user?.id}
                userPlan={post.user?.userPlan?.plan?.name?.toLowerCase()}
                // isFeatured={!!post.isHighlighted}
                isFeatured={true}
                hideUserInfo={true}
                // hideShare={true}
                // hideHeart={true}
                // hideLikes={true}
                // hideViews={true}
              />
            );
          })}
        </div>
      ) : (
        <>
          <div>
            <Swiper
              className="w-full xl:w-[788px] 2xl:w-full mt-5"
              breakpoints={{
                200: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 2,
                },
                1280: {
                  slidesPerView: 'auto',
                },
              }}
              // slidesPerView={2}
              speed={1000}
              spaceBetween={32}
              modules={[Pagination, Navigation]}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
            >
              <>
                <SwiperSlide className="swiper-slide w-fit">
                 
                    <Link to={"/business-dashboard/posts/create-post"}>
                      <div className="flex flex-col justify-center items-center gap-2 py-5 rounded-xl bg-white text-offblack xl:w-[413px] xl:h-[310px] aspect-[413/310]">
                        <i className="fi fi-rs-add text-[100px] hover:text-primaryblue"></i>
                        <AuxiliaryText variant={"FieldLabel"}>
                          Create new post
                        </AuxiliaryText>
                      </div>
                    </Link>
                 
                </SwiperSlide>
                {React.Children.toArray(
                  posts.map((post, index) => {
                    let images = [];
                    try {
                      if (post.content) {
                        const contentArray = JSON.parse(post.content);
                        images = contentArray.map(img => ({ url: img.url }));
                      }
                    } catch (e) {
                      images = [];
                    }
                    if (!images.length) images = [{ url: 'https://via.placeholder.com/300x200' }];
                    return (
                      <>
                        <SwiperSlide className="swiper-slide w-fit" key={index}>
                          <AdsCard
                            key={post.id}
                            serviceId={post.id}
                            serviceName={post.postTitle}
                            serviceDescription={post.postDescription}
                            Images={images}
                            companyName={post.user?.businessName || 'Provider'}
                            companyLogo={post.user?.profilePicture}
                            category={post.user?.serviceCategory}
                            likes={post.likes || 0}
                            views={post.views || 0}
                            reaction={false}
                            companyId={post.user?.id}
                            userPlan={post.user?.userPlan?.plan?.name?.toLowerCase()}
                            // isFeatured={!!post.isHighlighted}
                            isFeatured={true}
                            // hideUserInfo={true}
                            // hideShare={true}
                            // hideHeart={true}
                            // hideLikes={true}
                            // hideViews={true}
                          />
                        </SwiperSlide>
                      </>
                    );
                  })
                )}
              </>
          {posts.length > 1 && (
            <div className="lg:flex items-center justify-end gap-x-2 mt-5 hidden">
              <CircularButton
                variant={"prev30"}
                onClick={() => swiperRef.current?.slideNext()}
              ></CircularButton>
              <CircularButton
                variant={"next30"}
                onClick={() => swiperRef.current?.slidePrev()}
              ></CircularButton>
            </div>
          )}
            </Swiper>
          </div>

        </>
      )}
    </>
  );
};

export default UserGigs;
